module.exports = __webpack_public_path__ + "c27e9ebb35631753a1ec94015ba76514.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-14.png
// module id = 1783
// module chunks = 0